import { type EidCategories } from '@app/client';

export const addressStringToInsertTags = (addressString: string): EidCategories[] => {
    const insertTags: EidCategories[] = [];
    const separator = '|';
    const secondarySeparator = '=';
    const walletAddresses = addressString.includes(separator)
        ? addressString.split(separator)
        : addressString.includes(secondarySeparator)
          ? [addressString]
          : [];

    if (walletAddresses?.length) {
        walletAddresses.forEach((a) => {
            const tag = a.split(secondarySeparator);
            insertTags.push({ tag: tag[0], data: tag[1] } as unknown as EidCategories);
        });
    }

    return insertTags;
};
